export default "__VITE_ASSET__97fcd4f6__"